module.exports = __webpack_public_path__ + "static/img/16.a8bdbbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/16.png
// module id = PwaT
// module chunks = 4